const defaultTransitionLensConfig = {
  availableColors: [],
  defaultAlphaLevel: 0,
  defaultColor: "",
  defaultType: "",
  isEvolve: false
};
const customTransitionLensConfig = {
  isEvolve: false,
  defaultType: "SIGNATURE",
  defaultAlphaLevel: 0.5,
  defaultColor: "SIGNATURE-GEN8-BROWN",
  availableColors: [
    "SIGNATURE-GEN8-AMBER",
    "SIGNATURE-GEN8-AMETHYST",
    "SIGNATURE-GEN8-EMERALD",
    "SIGNATURE-GEN8-GRAY",
    "SIGNATURE-GEN8-SAPPHIRE",
    "SIGNATURE-GEN8-BROWN",
    "SIGNATURE-GEN8-GGREEN",
    "XTRACTIVE-NEWGEN-BLUE-MIRROR",
    "XTRACTIVE-GOLD-MIRROR",
    "XTRACTIVE-NEWGEN-GREEN-MIRROR",
    "XTRACTIVE-NEWGEN-BROWN",
    "XTRACTIVE-NEWGEN-GGREEN",
    "XTRACTIVE-NEWGEN-GRAY",
    "XTRACTIVE-NEWGEN-GREEN",
    "XTRACTIVE-PINK-MIRROR",
    "XTRACTIVE-POL-GRAY",
    "XTRACTIVE-RED-MIRROR",
    "XTRACTIVE-SILVER-MIRROR"
  ]
};
export {
  customTransitionLensConfig,
  defaultTransitionLensConfig
};
//# sourceMappingURL=transition-lens-config.js.map
